__turbopack_context__.v({
  "disabled": "BuildSelect-module-sass-module__oOPK1a__disabled",
  "disabled__value": "BuildSelect-module-sass-module__oOPK1a__disabled__value",
  "wrapper": "BuildSelect-module-sass-module__oOPK1a__wrapper",
});
